import { useEffect } from "react";
import { getToken } from "./api/config";
import { useNavigate } from "react-router";

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    const token = getToken();
    if (!token) {
      navigate("/login");
      return;
    }
    navigate("/personal");
  }, []);
  return <div></div>;
}

export default App;
